import { plugin, Mode } from 'light-component';
import { useTranslation } from '@common';
import { Thumbnail } from '../../component';
import { WidgetType } from '../types';
import { RichTextInputMode } from './input';
import { RichTextDesignMode } from './design';
import { RichTextViewMode } from './view';
import type { ReactElement } from 'react';
import type { RichTextProps } from './types';

export function RichText(props: RichTextProps): ReactElement | null {
  const [t] = useTranslation();

  if (props.mode === Mode.THUMBNAIL) {
    return (<Thumbnail icon='ShotEyesShortAnswerIcon' title={t('RichText')} toolTipContent={t('RichText')} />);
  }

  if (props.mode === Mode.DESIGN) {
    return (<RichTextDesignMode {...props} />);
  }

  if (props.mode === Mode.VIEW) {
    return (<RichTextViewMode {...props} />);
  }

  if (props.mode === Mode.INPUT) {
    return (<RichTextInputMode {...props} />);
  }

  return null;
}

RichText.prototype.type = WidgetType.RICHTEXT;
plugin.register({ kind: 'widget', component: RichText });
